<template>
  <div class="pd20x flex1">
    <div class="contentBox h100pct ofA">
      <div class="filter" style="padding:10px 20px">
        <div>
          <label>搜索：</label>
          <a-select v-model="selectVal" style="width: 120px">
            <a-select-option value="school_name">学校名称</a-select-option>
            <a-select-option value="major_name">专业名称</a-select-option>
          </a-select>
          <a-input-search 
            placeholder="请输入搜索内容" 
            v-model="searchInput" 
            style="width: 300px" 
            @search="onSearch" 
            class="mr10px"
          />
        </div>
      </div>
      <a-table
        :columns="columns"
        :data-source="data"
        :rowKey="'id'"
        :pagination="{pageSize: page.pageSize, total}"
        @change="changePage"
      >
        <template slot="operation" slot-scope="text, record">
          <a-space>
            <a-popconfirm
              title="确定要删除这条记录吗?"
              @confirm="() => deleteItem(record.id)"
              ok-text="确定"
              cancel-text="取消"
            >
              <a href="#">删除</a>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import * as http from '@/libs/analysis'

const columns = [
  { title: '学校', dataIndex: 'school_name', align: 'center' },
  { title: '省份', dataIndex: 'province_name', align: 'center' },
  { title: '专业名称', dataIndex: 'major_name', align: 'center' },
  { title: '学历', dataIndex: 'education', align: 'center' },
  { title: '提交用户', dataIndex: 'nickname', align: 'center' },
  { title: '创建时间', dataIndex: 'create_time', align: 'center', customRender: text => text || '-' },
  { title: '操作', dataIndex: 'operation', align: 'center', width: '120px', scopedSlots: { customRender: 'operation' } },
];

export default {
  name: 'subjectApply',
  data() {
    return {
      data: [],
      columns,
      searchInput: '',
      selectVal: 'school_name',
      total: 0,
      page: { page: 1, pageSize: 10 },
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        page: this.page.page,
        pageSize: this.page.pageSize,
        [this.selectVal]: this.searchInput || undefined
      };
      http.getApplyMajorList(params).then(res => {
        this.data = res.list || [];
        this.total = res.total || 0;
      });
    },
    onSearch() {
      this.page.page = 1;
      this.getData();
    },
    changePage(pagination) {
      this.page.page = pagination.current;
      this.getData();
    },
    deleteItem(id) {
      http.delApplyMajor({ id }).then(() => {
        this.$message.success('删除成功');
        this.getData();
      });
    }
  }
}
</script>

<style scoped>
.contentBox { background: #fff; }
.mr10px { margin-right: 10px; }
</style>
